import React from "react";

import { useTranslation } from "react-i18next";

import { observer } from "mobx-react";

import { BetStatusAbrv } from "@data-types/bet-slip/BetStatus";
import { Bet } from "@models";

export const Gain = observer(function Gain(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");

	const { bet } = props;

	if (bet.betStatus?.abrv !== BetStatusAbrv.WON) {
		return null;
	}

	if (bet.gain == null || bet.gain == 0) {
		return null;
	}
	return (
		<div className="bet__details__row u-type--wgt--medium u-color--sent--success">
			<div className="bet__details__col">{t("ITEM.ADDITIONAL_GAIN")}</div>
			<div className="bet__details__col">{bet.displayGain}</div>
		</div>
	);
});
